// ─── Composer-tool registry (external / community tools) ─────────────────────────
//
// Mirrors panels/index.ts. External composer-tool plugins push into `composerTools`;
// WhimerComposer's "apps" (grid) button renders them as a popup list. EMPTY today — the
// mechanism is in place so dropping a tool in is a one-liner (no WhimerComposer edit).
// Internal tools (stop/image/mic/phone) are NOT here; they stay inline by design.

import type { ComposerToolPlugin } from './types'

export const composerTools: ComposerToolPlugin[] = []

export function listComposerTools(): ComposerToolPlugin[] {
  return composerTools
}

export type { ComposerToolPlugin, ComposerToolContext } from './types'
